import { memo } from 'react'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { GENERAL_UPGRADE_POPUP_TYPE, UPGRADE_POPUP_OPENER_REF } from 'consts'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { transformTextVariables } from 'utils/text-transformation'
import * as Styled from './styled'

const HD_1080_QUALITY = 1080

const GetUnlimitedBanner = () => {
  const renderforestFastModel = useSelector(
    aiVideoSelectors.renderforestFastModel
  )
  const unlimitedMaxQuality = useSelector(
    aiVideoSelectors.renderforestFastUnlimitedMaxQuality
  )

  const modelName = renderforestFastModel?.name || 'Renderforest Fast'

  const hasUnlimitedModel = unlimitedMaxQuality !== null
  const needsHDUpgrade =
    hasUnlimitedModel && unlimitedMaxQuality < HD_1080_QUALITY

  const handleClick = () => {
    window.openUpgradePopup({
      type: GENERAL_UPGRADE_POPUP_TYPE,
      openerRef: UPGRADE_POPUP_OPENER_REF
    })
  }

  if (hasUnlimitedModel && !needsHDUpgrade) return null

  const translationKey = needsHDUpgrade
    ? T.GET_UNLIMITED_HD_GENERATIONS_BANNER
    : T.GET_UNLIMITED_GENERATIONS_BANNER

  return (
    <Styled.BannerWrapper onClick={handleClick}>
      <Styled.UpgradeIcon />
      <Styled.TextContent>
        {transformTextVariables(translate(translationKey), [
          { value: translate(T.UNLIMITED_LABEL), Comp: Styled.BoldText },
          { value: modelName }
        ])}
      </Styled.TextContent>
    </Styled.BannerWrapper>
  )
}

export default memo(GetUnlimitedBanner)
